import { useLocation } from 'react-router';
import { ScrollArea } from '@helios/ui';
import { useAuth } from '@/features/auth/authContext';
import { SettingsNav } from '@/features/settings/SettingsNav';
import { settingsNavGroupsForPermissions } from '@/navigation/registry';

/**
 * Second left rail, flush to the primary sidebar, only while the operator is
 * in Settings. Subpages are listed here — never as a hover flyout on the
 * account menu.
 */
export function SettingsRail() {
  const location = useLocation();
  const { authenticated, permissions } = useAuth();

  if (
    !authenticated ||
    (location.pathname !== '/settings' && !location.pathname.startsWith('/settings/'))
  ) {
    return null;
  }

  const groups = settingsNavGroupsForPermissions(permissions);
  if (groups.length === 0) {
    return null;
  }

  return (
    <aside
      aria-label="Settings"
      className="z-sidebar border-border/70 bg-card/70 shadow-elevation-3 backdrop-blur-glass hidden h-full w-52 shrink-0 flex-col border-r lg:flex"
    >
      <ScrollArea className="min-h-0 flex-1">
        <SettingsNav groups={groups} variant="rail" />
      </ScrollArea>
    </aside>
  );
}
